import { LockOutlined, MenuOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';

import { websiteCss } from './websiteCss';

/** Kiểu thiết bị xem trước. */
export type PreviewDevice = 'desktop' | 'mobile';

/** Bề ngang khung điện thoại — cỡ màn hình điện thoại phổ biến. */
const mobileWidth = 390;

/**
 * Khung trình duyệt mô phỏng: thanh địa chỉ, đầu trang và chân trang của mvalab.vn, nội dung ở giữa.
 *
 * Chỉ là bản mô phỏng để người viết thấy bài trông thế nào — website thật do bên làm frontend dựng theo cùng
 * bố cục này.
 */
export function WebsiteFrame({
  url,
  device,
  children,
}: {
  readonly url: string;
  readonly device: PreviewDevice;
  readonly children: ReactNode;
}): ReactNode {
  const isMobile = device === 'mobile';

  return (
    <div style={{ background: '#e9edf3', borderRadius: 12, padding: isMobile ? '24px 0' : 16 }}>
      <div
        style={{
          width: isMobile ? mobileWidth : '100%',
          maxWidth: '100%',
          margin: '0 auto',
          background: '#fff',
          borderRadius: isMobile ? 22 : 10,
          overflow: 'hidden',
          border: '1px solid #d6dbe4',
          boxShadow: '0 12px 40px rgba(15, 23, 42, 0.16)',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '8px 12px',
            background: '#f1f3f6',
            borderBottom: '1px solid #e2e6ec',
          }}
        >
          {isMobile ? null : (
            <div style={{ display: 'flex', gap: 6 }}>
              {['#ff5f57', '#febc2e', '#28c840'].map((color) => (
                <span key={color} style={{ width: 11, height: 11, borderRadius: '50%', background: color }} />
              ))}
            </div>
          )}
          <div
            style={{
              flex: 1,
              minWidth: 0,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              background: '#fff',
              borderRadius: 999,
              padding: '4px 12px',
              fontSize: 12.5,
              color: '#475569',
            }}
          >
            <LockOutlined style={{ color: '#16a34a' }} />
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{url}</span>
          </div>
        </div>

        <style>{websiteCss}</style>

        <div className="mv-site">
          <header className="mv-header">
            <div className="mv-logo">
              <b>
                <span>MVA</span>LAB
              </b>
              <small>TECH FOR SOLUTION</small>
            </div>
            <nav className="mv-nav">
              <span>Trang chủ</span>
              <span>VisionFlow</span>
              <span>Khóa học</span>
              <span>Giải pháp</span>
              <span>Dự án tiêu biểu</span>
              <span className="active">Blog</span>
              <span className="mv-contact">Liên hệ</span>
            </nav>
            <MenuOutlined className="mv-burger" />
          </header>

          {children}

          <footer className="mv-footer">
            <div>
              <b>MVA LAB</b> — Tech for solution
              <br />
              Machine Vision · PC Control · AI Inspection · Smart Automation
            </div>
            <div>© {new Date().getFullYear().toString()} MVA Lab · Bản xem trước trong ERP</div>
          </footer>
        </div>
      </div>
    </div>
  );
}
